import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Organization } from '../../types/organization.type';

@Component({
  selector: 'app-browse-organizations',
  templateUrl: './browse-organizations.component.html',
  styleUrls: ['./browse-organizations.component.scss'],
})
export class BrowseOrganizationsComponent implements OnInit {
  public organizations: Organization[] = [];

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    const organizations = this.route.snapshot.data['organizations']
      .data as Organization[];

    this.organizations = organizations.sort(
      (a, b) => b.event_count - a.event_count
    );
  }
}
